<div class="amd-main__header">
  @if (isDetail()) {
    <span class="amd-main__title">{{
      "accountManagement.dialog.addresses.title" | translate
    }}</span>
  } @else {
    <span class="amd-main__title">{{
      "accountManagement.dialog.addresses.editTitle" | translate
    }}</span>
    <div class="edit-actions">
      <button
        pButton
        size="small"
        type="button"
        [label]="'buttons.cancel' | translate"
        class="p-button-secondary"
        (click)="cancelEdit()"
      ></button>
      <button
        pButton
        size="small"
        type="button"
        [loading]="savingAddress()"
        [label]="'buttons.save' | translate"
        (click)="saveAddress()"
      ></button>
    </div>
  }
</div>

<div class="amd-main__content">
  @if (isDetail()) {
    <div>
      <div class="search-bar">
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input
            pInputText
            size="small"
            class="w-full"
            (input)="onGlobalFilter($event)"
            [placeholder]="
              'accountManagement.dialog.addresses.searchPlaceholder' | translate
            "
          />
        </p-iconfield>
      </div>
      <p-table
        #table
        class="addresses-table"
        size="small"
        [value]="addresses()"
        [globalFilterFields]="[
          'tipo_direccion',
          'direccion',
          'provincia',
          'codigo_postal',
        ]"
        [paginator]="addresses().length > rows()"
        [rows]="rows()"
        [loading]="loadingAddresses()"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="tipo_direccion">
              {{
                "accountManagement.dialog.addresses.columns.type" | translate
              }}
              <p-sortIcon field="tipo_direccion"></p-sortIcon>
            </th>
            <th pSortableColumn="direccion">
              {{
                "accountManagement.dialog.addresses.columns.address" | translate
              }}
              <p-sortIcon field="direccion"></p-sortIcon>
            </th>
            <th pSortableColumn="codigo_postal">
              {{
                "accountManagement.dialog.addresses.columns.postalCode"
                  | translate
              }}
              <p-sortIcon field="codigo_postal"></p-sortIcon>
            </th>
            <th pSortableColumn="poblacion">
              {{
                "accountManagement.dialog.addresses.columns.city" | translate
              }}
              <p-sortIcon field="poblacion"></p-sortIcon>
            </th>
            <th pSortableColumn="provincia">
              {{
                "accountManagement.dialog.addresses.columns.province"
                  | translate
              }}
              <p-sortIcon field="provincia"></p-sortIcon>
            </th>
            <th class="text-center">
              {{
                "accountManagement.dialog.addresses.columns.actions" | translate
              }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-addr let-i="rowIndex">
          <tr>
            <td>{{ addr.tipo_direccion }}</td>
            <td>{{ addr.direccion }}</td>
            <td>{{ addr.codigo_postal }}</td>
            <td>{{ addr.poblacion }}</td>
            <td>{{ addr.provincia }}</td>
            <td class="text-center">
              <button
                pButton
                type="button"
                class="p-button-text p-button-plain edit-btn"
                icon="pi pi-pencil"
                (click)="editAddress(i)"
              >
                <span class="sr-only">{{ "buttons.edit" | translate }}</span>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="5" class="text-center">
              {{ "accountManagement.dialog.addresses.notFound" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <div class="edit-area">
      <form [formGroup]="form">
        <eco-input-text
          label="accountManagement.dialog.addresses.columns.type"
          formControlName="tipo_direccion"
        ></eco-input-text>
        <eco-input-text
          label="accountManagement.dialog.addresses.columns.address"
          formControlName="direccion"
        ></eco-input-text>
        <eco-input-text
          label="accountManagement.dialog.addresses.columns.postalCode"
          formControlName="codigo_postal"
        ></eco-input-text>
        <eco-input-text
          label="accountManagement.dialog.addresses.columns.country"
          formControlName="pais"
        ></eco-input-text>
        <eco-input-text
          label="accountManagement.dialog.addresses.columns.province"
          formControlName="provincia"
        ></eco-input-text>
        <eco-input-text
          label="accountManagement.dialog.addresses.columns.city"
          formControlName="poblacion"
        ></eco-input-text>
      </form>
    </div>
  }
</div>
